import React from 'react';
import { Box, Button, Grid, makeStyles } from '@material-ui/core';
import {
  CUISINES_LABEL,
  POPULAR_SEARCHES_ALT_TEXT,
  POPULAR_SEARCHES_TEXT,
} from '../../../assets/copy';
import { ReactComponent as GravitySearchIcon } from '../../../assets/icons/grv-search.svg';
import clsx from 'clsx';
import Typography from '../../../components/overrides/Typography';
import { useDispatch } from 'react-redux';
import { FILTER_TYPES } from '../../../utils/constants/FilterTypes';
import { actionSetCurrentFilters } from '../../../store/Filter/FilterAction';
import { trackClickWithDescription } from '../../../utils/useOneTag';
import {
  actionSetSearchCurrentInputValue,
  actionSetSearchCurrentQuery,
} from '../../../store/Search/SearchAction';
import { useHistory } from 'react-router-dom';
import { useSearchRedirect } from '../../../components/search/helpers';
import { useItemsInMarket } from '../../../utils/useItemsInMarket';

const useStyles = makeStyles((theme) => ({
  root: {},
  popularSearchGridContainer: {
    marginTop: theme.spacing(1),
  },
  popularSearchText: {
    marginLeft: theme.spacing(1),
  },
  popularSearchItemButton: {
    textTransform: 'none',
    padding: 0,
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&:hover p, &:focus p': {
      color: theme.palette.secondary[65],
    },
    '&:hover path, &:focus p': {
      fill: theme.palette.secondary[65],
    },
    '&:active p': {
      color: theme.palette.secondary[80],
    },
    '&:active path': {
      fill: theme.palette.secondary[80],
    },
  },
  searchIcon: {
    width: theme.spacing(2.25),
  },
}));

export const PopularSearches = ({ classes: classesOverride }) => {
  const classes = useStyles({ classes: classesOverride });
  const dispatch = useDispatch();
  const { cuisines } = useItemsInMarket();
  const history = useHistory();
  const redirectTo = useSearchRedirect();

  const handlePopularSearchClick = (cuisine) => {
    dispatch(actionSetSearchCurrentQuery(''));
    dispatch(actionSetSearchCurrentInputValue(''));
    dispatch(actionSetCurrentFilters({ [FILTER_TYPES.CUISINES]: [cuisine] }));
    trackClickWithDescription('search-revamp-popular-searches-link', `Link`, `${cuisine.name} ${CUISINES_LABEL} ${POPULAR_SEARCHES_TEXT}`); 
    history.push('/search', { redirectTo });
  };

  return (
    <Box className={classes.root}>
      <Typography variant="medium1Semibold">{POPULAR_SEARCHES_TEXT}</Typography>
      <Grid
        container
        spacing={1}
        className={classes.popularSearchGridContainer}>
        {cuisines.map((cuisine, index) => (
          <Grid item xs={12} sm={6} key={index}>
            <PopularSearch
              handlePopularSearchClick={handlePopularSearchClick}
              cuisine={cuisine}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

const PopularSearch = ({ cuisine, handlePopularSearchClick }) => {
  const classes = useStyles();

  return (
    <Button
      disableRipple
      className={clsx(classes.popularSearchItemButton)}
      onClick={() => handlePopularSearchClick(cuisine)}
      aria-label={POPULAR_SEARCHES_ALT_TEXT}>
      <GravitySearchIcon
        className={classes.searchIcon}
        alt={POPULAR_SEARCHES_ALT_TEXT}
      />
      <Typography variant="small2Normal" className={classes.popularSearchText}>
        {cuisine.name}
      </Typography>
    </Button>
  );
};

export default PopularSearches;
